import i18n from "i18next";
import {  initReactI18next } from "react-i18next";
import englishJSON from './locales/en.json'
import spanishJSON from './locales/sp.json'
import russianJSON from './locales/ru.json'

i18n.use(initReactI18next).init({
  resources: {
    en: { ...englishJSON },
    es: { ...spanishJSON },
    ru: { ...russianJSON },
  },
  lng: "en",
  interpolation: { escapeValue: false },
});
